var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 52,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.919 47.472c.336.48.504.984.504 1.512 0 .72-.264 1.296-.792 1.728a2.576 2.576 0 01-1.656.576c-.624 0-1.152-.264-1.584-.792L15.303 25.224 5.511 34.44v14.328c-.048.672-.288 1.224-.72 1.656-.432.384-.96.576-1.584.576-.672 0-1.224-.192-1.656-.576-.384-.432-.576-.984-.576-1.656V2.832c0-.672.216-1.2.648-1.584C2.055.816 2.607.6 3.279.6c.672 0 1.2.216 1.584.648.432.384.648.912.648 1.584v26.136L34.599 1.464c.432-.48.96-.72 1.584-.72.576 0 1.056.216 1.44.648.432.432.648.912.648 1.44 0 .576-.216 1.08-.648 1.512l-18.864 17.64 20.16 25.488z",
    fill: "currentColor"
  })));
}
export default SvgK;